// Import our CSS
import '../scss/robust.scss'

// Import jQuery and add to window object
import $ from "jquery"
window.$ = $

// Robust's components
import './modules/bootstrap'
import './modules/timeago'
import './modules/flickity'
import './modules/medium-zoom'
import './modules/countdown';



// WEBPACK FOOTER //
// ./src/js/main.js